// extracted by mini-css-extract-plugin
export default {"products":"jA-z","card":"kA-z","oosMessaging":"lA-z"};